import { CheckCircle, XCircle, Trash2, Star, StarOff, Ban, UserCheck, EyeOff } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export const StatusBadge = ({ status }) => {
  const colors = {
    pending: 'bg-yellow-500/20 text-yellow-500',
    approved: 'bg-green-500/20 text-green-500',
    rejected: 'bg-red-500/20 text-red-500',
    published: 'bg-blue-500/20 text-blue-500',
  };
  return <Badge className={colors[status] || 'bg-gray-500/20'}>{status}</Badge>;
};

export const RegistrationCard = ({ item, type, onApprove, onReject, onDelete }) => (
  <Card className="bg-card border-border">
    <CardHeader className="pb-2 space-y-2">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
        <CardTitle className="text-base sm:text-lg break-words">{item.band_name || item.artist_name || item.venue_name || item.event_title || item.promoter_name || item.creator_name}</CardTitle>
        <StatusBadge status={item.status} />
      </div>
      <CardDescription className="text-xs sm:text-sm break-all">{item.email}</CardDescription>
    </CardHeader>
    <CardContent className="space-y-2">
      {item.genre && <p className="text-xs sm:text-sm"><span className="text-muted-foreground">Genre:</span> {item.genre}</p>}
      {item.venue_type && <p className="text-xs sm:text-sm"><span className="text-muted-foreground">Type:</span> {item.venue_type}</p>}
      {item.date && <p className="text-xs sm:text-sm"><span className="text-muted-foreground">Date:</span> {item.date}</p>}
      {item.bio && <p className="text-xs sm:text-sm text-muted-foreground line-clamp-2">{item.bio}</p>}
      {item.description && <p className="text-xs sm:text-sm text-muted-foreground line-clamp-2">{item.description}</p>}
      {item.status === 'pending' && (
        <div className="flex flex-col sm:flex-row gap-2 pt-2">
          <Button size="sm" variant="outline" className="flex-1" onClick={() => onApprove(item.id)}>
            <CheckCircle size={14} className="mr-1" /> Approve
          </Button>
          <Button size="sm" variant="ghost" className="flex-1" onClick={() => onReject(item.id)}>
            <XCircle size={14} className="mr-1" /> Reject
          </Button>
        </div>
      )}
      {onDelete && (
        <Button size="sm" variant="ghost" className="w-full text-destructive hover:text-destructive text-xs" onClick={() => onDelete(item.id)}>
          <Trash2 size={12} className="mr-1" /> Delete
        </Button>
      )}
    </CardContent>
  </Card>
);

export const ContentCard = ({ item, type, onFeature, onUnfeature, onBan, onUnban }) => (
  <Card className="bg-card border-border">
    <CardHeader className="pb-2 space-y-2">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
        <CardTitle className="text-base sm:text-lg break-words">{item.name}</CardTitle>
        <div className="flex flex-wrap gap-1">
          {item.is_featured && <Badge className="bg-yellow-500/20 text-yellow-500"><Star size={12} className="mr-1" />Featured</Badge>}
          {item.is_banned && <Badge className="bg-red-500/20 text-red-500"><Ban size={12} className="mr-1" />Banned</Badge>}
          {!item.is_active && !item.is_banned && <Badge className="bg-gray-500/20"><EyeOff size={12} className="mr-1" />Disabled</Badge>}
        </div>
      </div>
      <CardDescription className="text-xs sm:text-sm">{item.genre || item.cuisine || item.category}</CardDescription>
    </CardHeader>
    <CardContent>
      {item.image_url && (
        <img src={item.image_url} alt={item.name} className="w-full h-32 object-cover rounded-sm mb-3" />
      )}
      <div className="flex flex-wrap gap-2">
        {!item.is_featured ? (
          <Button size="sm" variant="outline" onClick={() => onFeature(item.id)}>
            <Star size={14} className="mr-1" /> Feature
          </Button>
        ) : (
          <Button size="sm" variant="outline" onClick={() => onUnfeature(item.id)}>
            <StarOff size={14} className="mr-1" /> Unfeature
          </Button>
        )}
        {!item.is_banned ? (
          <Button size="sm" variant="destructive" onClick={() => onBan(item.id)}>
            <Ban size={14} className="mr-1" /> Ban
          </Button>
        ) : (
          <Button size="sm" variant="outline" onClick={() => onUnban(item.id)}>
            <UserCheck size={14} className="mr-1" /> Unban
          </Button>
        )}
      </div>
    </CardContent>
  </Card>
);
